import { useTheme } from "@mui/material";

export default function ZigzagIcon() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  if (isDark) {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3178_2070)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.78239 2.73738C3.92178 2.44679 3.99989 2.12119 3.99989 1.77736C3.99989 1.43354 3.92181 1.10796 3.78242 0.817383H11.1111C13.3595 0.817383 15.1822 2.64009 15.1822 4.88853C15.1822 7.13694 13.3595 8.95966 11.1111 8.95966H10.0046C10.144 8.66907 10.2221 8.34347 10.2221 7.99963C10.2221 7.65582 10.144 7.33025 10.0046 7.03966H11.1111C12.2991 7.03966 13.2622 6.07656 13.2622 4.88853C13.2622 3.70049 12.2991 2.73738 11.1111 2.73738H3.78239ZM5.77756 7.99963C5.77756 8.34347 5.85567 8.66907 5.99506 8.95966H4.88869C3.70066 8.95966 2.73757 9.92276 2.73757 11.1108C2.73757 12.2989 3.70066 13.2619 4.88872 13.2619H12.2177C12.0783 13.5526 12.0001 13.8782 12.0001 14.222C12.0001 14.5658 12.0782 14.8914 12.2176 15.1819H4.88872C2.64028 15.1819 0.817566 13.3592 0.817566 11.1108C0.817566 8.86238 2.64028 7.03966 4.88869 7.03966H5.99503C5.85564 7.33025 5.77756 7.65582 5.77756 7.99963Z"
            fill="white"
          />
          <path
            d="M1.71431 3.4286C2.6611 3.4286 3.42863 2.66108 3.42863 1.7143C3.42863 0.767519 2.6611 0 1.71431 0C0.767524 0 0 0.767519 0 1.7143C0 2.66108 0.767524 3.4286 1.71431 3.4286Z"
            fill="white"
          />
          <path
            d="M8.00019 9.90526C9.05218 9.90526 9.90498 9.05247 9.90498 8.00048C9.90498 6.9485 9.05218 6.0957 8.00019 6.0957C6.9482 6.0957 6.0954 6.9485 6.0954 8.00048C6.0954 9.05247 6.9482 9.90526 8.00019 9.90526Z"
            fill="white"
          />
          <path
            d="M14.2856 15.9999C15.2324 15.9999 15.9999 15.2324 15.9999 14.2856C15.9999 13.3388 15.2324 12.5713 14.2856 12.5713C13.3388 12.5713 12.5713 13.3388 12.5713 14.2856C12.5713 15.2324 13.3388 15.9999 14.2856 15.9999Z"
            fill="#EB6087"
          />
        </g>
        <defs>
          <clipPath id="clip0_3178_2070">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3178_1706)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.78245 2.73738C3.92184 2.44679 3.99995 2.12119 3.99995 1.77736C3.99995 1.43354 3.92187 1.10796 3.78248 0.817383H11.1111C13.3596 0.817383 15.1823 2.64009 15.1823 4.88853C15.1823 7.13694 13.3596 8.95966 11.1111 8.95966H10.0046C10.144 8.66907 10.2221 8.34347 10.2221 7.99963C10.2221 7.65582 10.1441 7.33025 10.0047 7.03966H11.1111C12.2992 7.03966 13.2623 6.07656 13.2623 4.88853C13.2623 3.70049 12.2992 2.73738 11.1111 2.73738H3.78245ZM5.77762 7.99963C5.77762 8.34347 5.85573 8.66907 5.99512 8.95966H4.88875C3.70072 8.95966 2.73763 9.92276 2.73763 11.1108C2.73763 12.2989 3.70072 13.2619 4.88879 13.2619H12.2177C12.0783 13.5526 12.0002 13.8782 12.0002 14.222C12.0002 14.5658 12.0783 14.8914 12.2177 15.1819H4.88879C2.64034 15.1819 0.817627 13.3592 0.817627 11.1108C0.817627 8.86238 2.64034 7.03966 4.88875 7.03966H5.99509C5.8557 7.33025 5.77762 7.65582 5.77762 7.99963Z"
          fill="#181A46"
        />
        <path
          d="M1.71431 3.4286C2.6611 3.4286 3.42863 2.66108 3.42863 1.7143C3.42863 0.767519 2.6611 0 1.71431 0C0.767524 0 0 0.767519 0 1.7143C0 2.66108 0.767524 3.4286 1.71431 3.4286Z"
          fill="#181A46"
        />
        <path
          d="M8.00025 9.90526C9.05224 9.90526 9.90505 9.05247 9.90505 8.00048C9.90505 6.9485 9.05224 6.0957 8.00025 6.0957C6.94826 6.0957 6.09546 6.9485 6.09546 8.00048C6.09546 9.05247 6.94826 9.90526 8.00025 9.90526Z"
          fill="#181A46"
        />
        <path
          d="M14.2856 15.9999C15.2324 15.9999 15.9999 15.2324 15.9999 14.2856C15.9999 13.3388 15.2324 12.5713 14.2856 12.5713C13.3388 12.5713 12.5713 13.3388 12.5713 14.2856C12.5713 15.2324 13.3388 15.9999 14.2856 15.9999Z"
          fill="#D51A4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3178_1706">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
